import {Component, OnInit} from '@angular/core';
import {AdService} from '@services/ad.service';
import {Favorite} from '@models/favorite';
import {MatDialog} from '@angular/material/dialog';
import {AddCompareComponent} from '@module/favorites/popup/add-compare/add-compare.component';
import {environment} from '~/environments/environment';
import {HttpClient} from '@angular/common/http';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';
import {TrackingService} from '@services/tracking.service';
import {Title} from '@angular/platform-browser';
import {UpgradePlanV2Component} from '@components/popup/upgrade-plan-v2/upgrade-plan-v2.component';
import {LoginFormComponent} from '@components/popup/login-form/login-form.component';
import {ImageService} from '@services/image.service';

@Component({
    selector: 'app-compare',
    templateUrl: './compare.component.html',
    styleUrls: ['./compare.component.scss']
})
export class CompareComponent implements OnInit {

    loading = true;
    cpt = 0;
    diff = '1';
    favorites: Favorite[] = [];
    user: User = Object.assign({}, EMPTY_USER);
    impots = [];
    comparatif = [];

    constructor(private adService: AdService,
                public authenticationService: AuthenticationService,
                private http: HttpClient,
                private titleService: Title,
                public trackingService: TrackingService,
                public imageService: ImageService,
                public dialog: MatDialog) {
    }

    ngOnInit(): void {
        this.user = this.authenticationService.currentUser;
        this.titleService.setTitle('LyBox - ' + 'Comparatif de projet');

        if (!this.authenticationService.isAllowed('essentiel')) {
            this.trackingService.click('favorite_list_upgrade_plan', 'Comparaison entre projets');
            if (!this.authenticationService.isLogin) {
                const dialogRef = this.dialog.open(LoginFormComponent, {
                    width: '550px',
                    data: {
                        disableClose: false
                    },
                });
            } else {
                const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                    width: '520px',
                    data: {visuel: 'assets/upgrade/compare.png', plan: 'Essentiel', feature: 'Comparaison entre projets'}
                });
            }
            this.loading = false;
            return
        }

        this.adService.getCompareAd().subscribe(ids => {
            if (ids.length === 0) {
                this.loading = false;
            }

            console.log('Compare ads');
            console.log(ids);

            ids.forEach((favoriteId, i) => {
                this.adService.getFavorite(favoriteId).subscribe(result => {
                    this.favorites[i] = this.adService.updateValues(result);

                    const fav = this.adService.cleanForImpot(this.favorites[i], this.user);
                    fav.is_credit_differed = false;
                    this.http.post<any>(environment.impotUrl, fav)
                        .subscribe(data => {
                            var fc = this.favorites[i].fiscal_choice;
                            if (fc == "") {
                                fc = "Foncier reel"
                            }
                            if (data[fc] && data[fc].cols !== undefined) {
                                this.impots[i] = data[fc].impots;
                                this.comparatif[i] = data.comparatif[fc];
                            }
                            this.cpt++;
                            if (this.cpt === ids.length) {
                                this.loading = false;
                            }
                        });

                }, error => {
                    if (error != "token_outdate") {
                        this.adService.deleteCompareAd(favoriteId);
                    }
                });
            });
        });
    }

    addFavorite() {
        const dialogRef = this.dialog.open(AddCompareComponent, {
            width: '400px',
            data: {},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.ngOnInit();
            }
        });
    }

    remove(favoriteId) {
        this.adService.deleteCompareAd(favoriteId);
        this.favorites.forEach((favorite, i) => {
            if (favorite.id === favoriteId) {
                this.favorites.splice(i, 1);
            }
        });
    }

    setMain(favoriteId) {
        this.adService.setMainCompareAd(favoriteId);
        this.favorites.forEach((favorite, i) => {
            if (favorite.id === favoriteId) {
                this.favorites.splice(i, 1);
                this.favorites.unshift(favorite);
            }
        });
    }
}
